var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZmrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0058 0.262212C15.707 0.2604 13.4305 0.711834 11.3063 1.59069C9.18222 2.46955 7.25223 3.75862 5.62676 5.38409C4.0013 7.00956 2.71223 8.93954 1.83337 11.0637C0.95451 13.1878 0.503076 15.4643 0.504888 17.7631C0.504888 30.8868 18.0058 50.2622 18.0058 50.2622C18.0058 50.2622 35.5047 30.8868 35.5047 17.7631C35.5065 15.4645 35.0552 13.1881 34.1764 11.0641C33.2977 8.94015 32.0088 7.01019 30.3835 5.38475C28.7583 3.75931 26.8285 2.47027 24.7046 1.59129C22.5807 0.712319 20.3044 0.260659 18.0058 0.262212Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0805 21.1476L27.8163 24.4053L23.5733 20.163L19.3329 24.4053L16.0754 21.1476L20.3185 16.9053L16.0754 12.663L19.3329 9.40527L23.5746 13.6476L27.8176 9.40527L31.0805 12.663L26.8375 16.9053L31.0805 21.1476Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6796 10.1379L17.447 16.9053L10.6796 23.6727V19.9606H2.94507L5.49097 13.8515H10.6796V10.1379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZmrc);
export default __webpack_public_path__ + "static/media/ZMRC.1ff4001265bb7084bd6d478cb64cf5f6.svg";
export { ForwardRef as ReactComponent };